import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Employee } from "src/api/types";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { columns } from "../../utils/columns";

interface Props {
  row: Employee;
}

const EmployeesTableRow = ({ row }: Props) => {
  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      {columns.map((column) => {
        return (
          <TableCell
            width={column.minWidth}
            key={column.id}
            align={column.align}
          >
            {column.id === "employee" ? (
              <Link to={`${row.id}`}>{column.format(row)}</Link>
            ) : (
              <Typography>{column.format(row)}</Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default EmployeesTableRow;
